import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import Zoom from "react-medium-image-zoom";
// import UploadIcon from "@mui/icons-material/Upload";
// import layoutIm from "../../../assets/Images/spot1.png";
import CreateIcon from "@mui/icons-material/Create";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import FileUploadIcon from "@mui/icons-material/FileUpload";
// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EmojiTransportationIcon from "@mui/icons-material/EmojiTransportation";
import AddIcon from "@mui/icons-material/Add";

import {
  uploadFileRequest,
  makeGetRequest,
  makePostRequest,
} from "../../../utils/utils";
import swal from "sweetalert";

// End
import { Formik, Form } from "formik";
import * as Yup from "yup";

// import EditIcon from "@mui/icons-material/Edit";

function BuildingYes() {
  const navigate = useNavigate();
  const [pdfImage] = React.useState(
    require("../../../assets/Images/pdf.png")
  );
  const [txtImage] = React.useState(
    require("../../../assets/Images/text.png")
  );
  const [excelImage] = React.useState(
    require("../../../assets/Images/exel.png")
  );
  const [wordImage] = React.useState(
    require("../../../assets/Images/doc.png")
  );

  const [defaultBuildImage] = React.useState(
    require("../../../assets/Images/defaultBuilding.png")
  );

  // const addCommitee = () => {
  //   var element = document.getElementById("successfullAdd");
  //   element.classList.toggle("hideModal");
  // };

  // For Modal
  const [open2, setOpen2] = React.useState(false);
  const [, setScroll2] = React.useState("paper");

  const handleClickOpen2 = (scrollType) => () => {
    setOpen2(true);
    setScroll2(scrollType);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  // const descriptionElementRef2 = React.useRef(null);
  // React.useEffect(() => {
  //   if (open2) {
  //     const { current: descriptionElement } = descriptionElementRef;
  //     if (descriptionElement !== null) {
  //       descriptionElement.focus();
  //     }
  //   }
  // }, [open2]);
  // End

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");

  const [wingname, setWingname] = React.useState("");
  const [totalfloor, setTotalfloor] = React.useState("");
  const [aprt, setAprt] = React.useState("");
  const [aprtparking, setAprtParking] = React.useState("");
  const [wingId, setWingId] = React.useState();

  const [ed_societyImage] = React.useState("");
  const [ed_societyName, setEdSocietyName] = React.useState("");
  const [ed_emailId, setEdEmailId] = React.useState("");
  const [ed_contact, setEdContact] = React.useState("");
  const [ed_buildingCount, setEdBuildingCount] = React.useState(0);
  const [ed_address, setEdAddress] = React.useState("");
  const [ed_spotLayout] = React.useState("");
  const [ed_GoogleMap] = React.useState("");
  //   const [ed_XAxis, setEdXAxis] = React.useState("");
  //   const [ed_YAxis, setEdYAxis] = React.useState("");
  // const [ed_latitude, setEdLatitude] = React.useState("");
  // const [ed_longitude, setEdLongitude] = React.useState("");

  // const [societyId, setSocietyId] = React.useState("");
  // const [societyObj, setSocietyObj] = React.useState({});
  const [documentsList, setDocumentsList] = React.useState([]);
  const [buildingList, setBuildingList] = React.useState([]);

  const [, setSelectedBuilding] = React.useState({});
  const [build_DocumentsList, setBuild_DocumentsList] = React.useState([]);
  const [wingList, setWingList] = React.useState([]);
  const [selectedWingIndex, setSelectedWingIndex] = React.useState(0);
  const [selectedBuildIndex, setSelectedBuildIndex] = React.useState(0);

  const [selectedBuildingId, setSelectedBuildingId] = React.useState();
  const [selectedBuildingName, setSelectedBuildingName] = React.useState();
  const [selectedBuilTotWing, setSelectedBuilTotWing] = React.useState();

  const [, setSelectedWingId] = React.useState();
  const [selectedWingName, setSelectedWingName] = React.useState();
  const [, setFloors_per_wing] = React.useState();
  const [, setApartment_per_floor] = React.useState();
  const [lstAptHashmap, setLstAptHashmap] = React.useState([]);
  const [allocatedApartments, setAllocatedApartments] = React.useState([]);
  const [Update, setUpdate] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(false);
  const [isAddWing, setIsWingAdd] = React.useState(false);
  const [isBuildingAdd, setIsBuildingAdd] = React.useState(false);

  var formikInitials = {
    wingname: wingname,
    totalfloor: totalfloor,
    aprt: aprt,
    aprtparking: aprtparking,
  };

  const Validation_Schema = Yup.object().shape({
    wingname: Yup.string()
      .required("Required")
      .trim("White spaces not allow")
      .strict(true),
    totalfloor: Yup.string()
      .required("Required")
      .matches(/^\d+$/, "The field should have digits only"),
    aprt: Yup.string()
      .required("Required")
      .matches(/^\d+$/, "The field should have digits only"),
    aprtparking: Yup.string()
      .required("Required")
      .matches(/^\d+$/, "The field should have digits only"),
  });

  const [, setIsEditWing] = React.useState(false);
  const [isDataLoaded, setIsDataLoaded] = React.useState(false);

  const handleClickOpen = (scrollType, wingData, index) => () => {
    setOpen(true);
    setScroll(scrollType);

    setAptPerFloorErrorMsg("");
    setWingNameErrMsg("");
    setFloorPerWingErrorMsg("");
    setParkingPerAptmtErrorMsg("");

    // setSelectedBuildingId(selectedBuilding.building_id);
    setIsEditWing(true);
    setWingname(wingData.wing_name);
    setTotalfloor(wingData.floors_per_wing);
    setAprt(wingData.apartment_per_floor);
    setAprtParking(wingData.parking_per_apartment);
    setWingId(wingData.wing_id);

    localStorage.setItem("wing_id_new", wingData.wing_id);
    localStorage.setItem("wingIndex", index);
  };

  var formikInitials_EditSociety = {
    ed_societyName: ed_societyName,
    ed_emailId: ed_emailId,
    ed_contact: ed_contact,
    ed_buildingCount: ed_buildingCount,
    ed_address: ed_address,
    // ed_XAxis: ed_XAxis,
    // ed_YAxis: ed_YAxis,
    //  ed_latitude:ed_latitude,
    //  ed_longitude:ed_longitude,
  };

  const Validation_Schema_Editsociety = Yup.object().shape({
    ed_societyName: Yup.string()
      .required("Required")
      .trim("White spaces not allow")
      .strict(true),
    ed_address: Yup.string()
      .required("Required")
      .trim("White spaces not allow")
      .strict(true),
    ed_contact: Yup.string()
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
        "Contact number is not valid"
      )
      .min(10, "Contact no must be 10 digits long")
      .max(10, "Contact no must be 10 digits long")
      .required("Required"),
    ed_emailId: Yup.string()
      .matches(
        /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/,
        "Invalid Email Id"
      )
      .email("Invalid email")
      .required("Required"),
    ed_buildingCount: Yup.string()
      .matches(/^[0-9\b]+$/, "Building Count is not valid")
      .min(0, "Building Count Must Be Less Than Or Equal To 15")
      .max(15, "Building Count Must Be Less Than Or Equal To 15")
      .required("Required"),
  });

  const [, setContactErrMsg] = React.useState("");
  const [buildingCntErrMsg, setBuildingCntErrMsg] = React.useState("");

  async function editSociety() {
    let isEditable = false;
    setBuildingCntErrMsg("");

    if (localStorage.getItem("buildingCnt") === 0) {
      if (ed_societyName && ed_contact && ed_emailId && ed_address) {
        if (ed_contact.length === 10) {
          isEditable = true;
        } else {
          setContactErrMsg("Contact no must be 10 digits long");
        }

        // if(ed_buildingCount>0)
        //   {
        //     setBuildingCntErrMsg("Invalid Building Count B")
        //       isEditable = false;
        //   }
      }
    } else {
      if (
        ed_societyName &&
        ed_contact &&
        ed_emailId &&
        ed_address &&
        ed_buildingCount
      ) {
        if (ed_contact.length === 10) {
          isEditable = true;
        } else {
          setContactErrMsg("Contact no must be 10 digits long");
        }

        let tempBuilCnt = localStorage.getItem("buildingCnt");

        if (tempBuilCnt!== 0) {
          if (ed_buildingCount < buildingList.length) {
            setBuildingCntErrMsg("Invalid Building Count");
            isEditable = false;
          }
        }
      }
    }
    if (isEditable) {
      let inputdata = {
        society_id: localStorage.getItem("socityid"),
        society_name: ed_societyName,
        contact: ed_contact,
        email_id: ed_emailId,
        address: ed_address,
        building_count: ed_buildingCount,
      };
      setShowLoader(true);
      await makePostRequest("society/update", inputdata)
        .then((response) => {
          if (response.data.data !== undefined) {
            // swal("Success", "Society updated successfully", "success", {
            //   timer: 1000,
            //   buttons: false,
            // });
            localStorage.setItem(
              "buildingCnt",
              response.data.data.building_count
            );
            setOpen2(false);
            window.location.reload();
          }
          setShowLoader(false);
        })
        .catch((err) => {
          console.log(err);
          swal("There was an error!", "more error details", "warning");
        });
    }
  }

  const [wingNameErrorMsg, setWingNameErrMsg] = React.useState("");
  const [floorPerWingErrorMsg, setFloorPerWingErrorMsg] = React.useState("");
  const [aptPerFloorErrorMsg, setAptPerFloorErrorMsg] = React.useState("");
  const [parkingPerAptmtErrorMsg, setParkingPerAptmtErrorMsg] =
    React.useState("");

  async function updateWing() {
    setWingNameErrMsg("");
    setAptPerFloorErrorMsg("");
    setFloorPerWingErrorMsg("");
    setParkingPerAptmtErrorMsg("");

    let inputdata;
    let isWingEditable = true;

    await makeGetRequest("wing/checkiswingeditable/" + wingId)
      .then((response) => {
        console.log("In Edit Wing ", response);
        if (response.data.data.length > 0) {
          isWingEditable = false;
          // swal("Warning","Wing is already assigned unable to update data.","warning",{
          //   timer: 3000,
          //   buttons: false,
          // })
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
    let conditionsChecked = true;
    if (isWingEditable) {
      if (totalfloor == 0) {
        setFloorPerWingErrorMsg("Invalid Value");
        conditionsChecked = false;
      }
      if (aprt == 0) {
        setAptPerFloorErrorMsg("Invalid Value");
        conditionsChecked = false;
      }
      for (var i = 0; i < wingList.length; i++) {
        let obj = wingList[i];

        if (
          wingname.toLowerCase().localeCompare(obj.wing_name.toLowerCase()) ==
          0 &&
          wingId != obj.wing_id
        ) {
          setWingNameErrMsg("Wing with given name already exist");
          conditionsChecked = false;
          break;
        }
      }
      if (conditionsChecked) {
        inputdata = {
          wing_id: wingId,
          wing_name: wingname,
          floors_per_wing: totalfloor,
          apartment_per_floor: aprt,
          parking_per_apartment: aprtparking,
        };
      }
    } else {
      let data;
      await makeGetRequest("wing/getbyid/" + wingId)
        .then((response) => {
          if (response.status === 201) {
            data = response.data.data;
          }

          if (wingname.localeCompare(data.wing_name.toString()) != 0) {
            setWingNameErrMsg(
              "Wing is already assigned unable to change name.  "
            );
            conditionsChecked = false;
          }
          if (parseInt(totalfloor) < data.floors_per_wing) {
            setFloorPerWingErrorMsg(
              "Unable to set floor value less than previous one."
            );
            conditionsChecked = false;
          }
          if (parseInt(aprt) < data.apartment_per_floor) {
            setAptPerFloorErrorMsg(
              "Unable to set apartment value less than previous one."
            );
            conditionsChecked = false;
          }

          if (conditionsChecked) {
            inputdata = {
              wing_id: wingId,
              wing_name: wingname,
              floors_per_wing: totalfloor,
              apartment_per_floor: aprt,
              parking_per_apartment: aprtparking,
            };
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }

    if (inputdata) {
      await makePostRequest("wing/update", inputdata)
        .then((response) => {
          if (response.data.data !== undefined) {
            swal("Success", "Wing Updated successfully", "success", {
              timer: 3000,
              buttons: false,
            });

            let updatedWing = response.data.data;
            setOpen(false);
            handleWingSelected(response.data.data.wing_id);
          }
        })
        .catch((err) => {
          swal("There was an error!", "more error details", "warning");
        });
    }
    setIsEditWing(false);
  }

  async function deleteWing(wingId) {
    let isWingDelete = true;
    await makeGetRequest("wing/checkiswingeditable/" + wingId)
      .then((response) => {
        console.log("In delete Wing ", response);
        if (response.data.data.length > 0) {
          // setIsWingEditable(true)
          isWingDelete = false;
          swal(
            "Warning",
            "Wing is already assigned unable to delete wing.",
            "warning",
            {
              timer: 3000,
              buttons: false,
            }
          );
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
    if (isWingDelete) {
      if (wingList.length > 1) {
        const willDelete = await swal({
          title: "Are you sure?",
          text: "Do you really want to delete this wing? This process cannot be undone.",
          icon: "warning",
          buttons: ["No", "Yes"],
        });

        if (willDelete) {
          await makeGetRequest("wing/delete/" + wingId)
            .then((response) => {
              if (response.data.status === "1") {
                swal("Success", "Wing deleted successfully", "success", {
                  timer: 3000,
                  buttons: false,
                });
                buildinglisting();
                // window.location.reload();
              } else {
                swal("Error", "Failed to delete", "error");
              }
            })
            .catch((err) => {
              swal("There was an error!", "more error details", "warning");
              console.log("Invalid username password!!", err);
            });
        }
      } else {
        swal(
          "Warning",
          "You can't delete all wings, At least one wing required. If you want you can update wing details.",
          "warning",
          {
            timer: 4000,
            buttons: false,
          }
        );
      }
    }
  }

  async function deleteBuilding(id) {
    let isBuildingDelete = true;
    await makeGetRequest("building/checkisbuildingeditable/" + id)
      .then((response) => {
        console.log("In delete Building ", response);
        if (response.data.data.length > 0) {
          isBuildingDelete = false;
          swal(
            "Warning",
            "Building is already assigned unable to delete building.",
            "warning",
            {
              timer: 3000,
              buttons: false,
            }
          );
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
    if (isBuildingDelete) {
      const willDelete = await swal({
        title: "Are you sure?",
        text: "Do you really want to delete these records? This process cannot be undone.",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      });

      if (willDelete) {
        var bodyFormData = new FormData();
        await makeGetRequest("building/delete/" + id, bodyFormData)
          .then((response) => {
            if (response.data.status === "1") {
              swal("Success", "Record deleted successfully", "success", {
                timer: 3000,
                buttons: false,
              });
              buildinglisting();
              setWingList([]);
            } else {
              swal("Error", "Failed to delete", "error");
            }
          })
          .catch((err) => {
            swal("There was an error!", "more error details", "warning");
            console.log("Invalid username password!!", err);
          });
      }
    }
  }

  const handleClose = () => {
    setOpen(false);
  };

  async function validateImageOrFile(fileData) {
    if (
      fileData.name.match(
        /.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF|docx|DOCX|doc|DOC|pdf|PDF|xls|XLS|txt|TXT|xlsx|XLSX)$/i
      )
    )
      return true;
    else return false;
  }

  async function validateImage(fileData) {
    if (fileData.name.match(/.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF)$/i))
      return true;
    else return false;
  }

  async function uploadImageOrFile(fileData) {
    const formData = new FormData();
    formData.append("image", fileData);
    var fileUrl;

    await uploadFileRequest("guards/uploadImages", formData).then(
      (response) => {
        fileUrl = response.data.imagepath[0].location;
        console.log(response.data.imagepath[0]);
      }
    );
    return fileUrl;
  }
  let document;
  let tempArr = [];

  const [gmaperrormsg, setGmapErrorMsg] = React.useState("");
  const [spoterrormsg, setSpotErrMsg] = React.useState("");
  const [socimgrrormsg, setSocImgErrMsg] = React.useState("");

  async function uploadDocuments(e, type) {
    // handle validations
    setDocErrorMsg("");
    setGmapErrorMsg("");
    setSpotErrMsg("");
    setSocImgErrMsg("");

    const file = e.target.files[0];
    let validateRes;
    if (!type) {
      validateRes = await validateImageOrFile(file);
    } else {
      validateRes = await validateImage(file);
    }

    if (validateRes) {
      setShowLoader(true);

      document = await uploadImageOrFile(file);

      let inputData = {
        society_id: localStorage.getItem("socityid"),
      };
      if (type == "spotLayout") {
        inputData.spot_layout = document;
      } else if (type == "googleMap") {
        inputData.google_map_image = document;
      } else if (type == "societyImage") {
        inputData.society_image = document;
      } else {
        documentsList.push(document);
        setDocumentsList(documentsList);

        setUpdate(!Update);
        inputData.document_list = documentsList;
      }

      await makePostRequest("society/update", inputData)
        .then((response) => {
          console.log("Society Update Response ", response);
          if (response.data.data !== undefined) {
            // window.location.reload();
            // setGoogleMapImage(response.data.data.google_map_image);
            if (response.data.data.society_image)
              setSocietyImage(response.data.data.society_image);
            if (response.data.data.google_map_image)
              setGoogleMapImage(response.data.data.google_map_image);
            if (response.data.data.spot_layout)
              setSpotLayout(response.data.data.spot_layout);
            if (response.data.data.document_list)
              setDocumentsList(response.data.data.document_list);
          }
          setShowLoader(false);
        })
        .catch((err) => {
          console.log(err);
          swal("There was an error!", "more error details", "warning");
        });

      setShowLoader(false);
    } else {
      if (type == "spotLayout") {
        setSpotErrMsg("Invalid File Format");
      } else if (type == "googleMap") {
        setGmapErrorMsg("Invalid File Format");
      } else if (type == "societyImage") {
        setSocImgErrMsg("Invalid File Format");
      } else {
        setDocErrorMsg("Invalid File Format");
      }
    }
  }

  async function deleteDocument(index) {
    documentsList.splice(index, 1); // 2nd parameter means remove one item only
    setDocumentsList(documentsList);
    let inputdata = {
      society_id: localStorage.getItem("socityid"),
      document_list: documentsList,
    };
    setShowLoader(true);
    await makePostRequest("society/update", inputdata)
      .then((response) => {
        if (response.data.data !== undefined) {
        }
        setShowLoader(false);
      })
      .catch((err) => {
        console.log(err);
        swal("There was an error!", "more error details", "warning");
      });
  }

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }

    if (open2) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
    console.log(allocatedApartments);
    console.log(allocatedApartments.includes("101"));
    // GetUserData();
    if (localStorage.getItem("socityid") && isDataLoaded == false) {
      GetSocietyById(localStorage.getItem("socityid"));
    }
  }, [open, open2]);

  const [societyName, setSocietyName] = React.useState("");
  const [societyImage, setSocietyImage] = React.useState("");
  const [contact, setContact] = React.useState("");
  const [emailId, setEmailId] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [buildingCnt, setBuildingCnt] = React.useState("");
  const [googleMapImage, setGoogleMapImage] = React.useState("");
  const [spotLayout, setSpotLayout] = React.useState("");
  const [docErrorMsg, setDocErrorMsg] = React.useState("");

  async function GetSocietyById(societyId) {
    var societyData = "";
    var bodyFormData = "";
    setShowLoader(true);
    await makeGetRequest("society/getbyid/" + societyId, bodyFormData)
      .then((response) => {
        console.log("Society Data ", response);
        if (response.status === 201) {
          societyData = response.data.data;

          setIsDataLoaded(true);
          // setSocietyObj(societyData);
          setSocietyName(societyData.society_name);
          if (societyData.society_image)
            setSocietyImage(societyData.society_image);
          setContact(societyData.contact);
          setEmailId(societyData.email_id);
          setAddress(societyData.address);
          setBuildingCnt(societyData.building_count);
          if (societyData.google_map_image)
            setGoogleMapImage(societyData.google_map_image);
          if (societyData.spot_layout) setSpotLayout(societyData.spot_layout);

          if (societyData.document_list)
            setDocumentsList(societyData.document_list);

          setBuildingCntErrMsg("");
          setEdSocietyName(societyData.society_name);
          setEdAddress(societyData.address);
          setEdBuildingCount(societyData.building_count);
          setEdContact(societyData.contact);
          setEdEmailId(societyData.email_id);
          // setEdGoogleMap()

          if (societyData.building_count != 0) buildinglisting();
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
    // return societyObj;
  }

  async function buildinglisting() {
    let bodyFormData = "";

    await makeGetRequest(
      "building/getall/" + localStorage.getItem("socityid"),
      bodyFormData
    )
      .then((response) => {
        if (response.status === 201) {
          const data = response.data.data.rows;
          console.log("Building Data", data);
          localStorage.setItem("addedbuildingCnt", data.length);
          let tempBuilCnt = localStorage.getItem("buildingCnt");
          if (data.length < tempBuilCnt) setIsBuildingAdd(true);
          else setIsBuildingAdd(false);

          setBuildingList(data);
          setSelectedBuilding(data[0]);
          setSelectedBuildingName(data[0].building_name);
          setSelectedBuilTotWing(data[0].tot_wing);
          setBuild_DocumentsList(data[0].document_list);
          setSelectedBuildingId(data[0].building_id);
          setSelectedBuildIndex(data[0].building_id);

          if (data[0].is_wing) {
            setWingList(data[0].wing);
            setSelectedWingIndex(data[0].wing[0].wing_id);
            handleWingSelected(data[0].wing[0].wing_id);
            if (data[0].wing.length < data[0].tot_wing) setIsWingAdd(true);
            else setIsWingAdd(false);
          }
        } else {
          setBuildingList([]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function handleBuildingSelected(buildingId) {
    setSelectedBuildIndex(buildingId);
    await makeGetRequest("building/getbyid/" + buildingId)
      .then((response) => {
        if (response.status === 201) {
          const data = response.data.data;
          console.log("Selected Building Data", data);
          setSelectedBuilding(data);
          setBuild_DocumentsList(data.document_list);
          setSelectedBuildingId(data.building_id);
          setSelectedBuildingName(data.building_name);
          setSelectedBuilTotWing(data.tot_wing);

          if (data.wing != null) {
            setWingList(data.wing);
            setSelectedWingIndex(data.wing[0].wing_id);
            handleWingSelected(data.wing[0].wing_id);
            if (data.wing.length < data.tot_wing) setIsWingAdd(true);
            else setIsWingAdd(false);
          } else {
            setWingList([]);
            setSelectedWingIndex();
            setSelectedWingId();
            setAllocatedApartments([]);
            setLstAptHashmap([]);
            setSelectedWingName("");
            setApartment_per_floor("");
            setFloors_per_wing("");

            // setSelectedWingName();
            // setApartment_per_floor();
            // setFloors_per_wing();
            // setLstAptHashmap();
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function handleWingSelected(wingId) {
    setShowLoader(true);
    await makeGetRequest("wing/getbyid/" + wingId)
      .then((response) => {
        if (response.status === 201) {
          const data = response.data.data;
          console.log("wing Data", response.data);
          // setAllocatedApartments([]);
          setSelectedWingIndex(data.wing_id);
          setSelectedWingId(data.wing_id);
          setSelectedWingName(data.wing_name);
          setApartment_per_floor(data.apartment_per_floor);
          setFloors_per_wing(data.floors_per_wing);
          setLstAptHashmap(response.data.lstHashmap);

          // setAllocatedApartments(data.res);
          // setAllocatedApartments([...allocatedApartments, data.res.apartment_no])

          // for(var i=0;i<data.res.length;i++)
          // {
          //     console.log("Iterated ",i);
          //     allocatedApartments.push(data.res[i].apartment_no);
          // }

          let arr = [];

          // Loop through the car object
          if (data.res) {
            for (let i of data.res) {
              // Push the values of every object into arr
              arr.push(...Object.values(i));
            }
            console.log(arr);

            setAllocatedApartments(arr);
            console.log("Alloca " + allocatedApartments);
          } else {
            setAllocatedApartments([]);
          }
          setShowLoader(false);
        }
      })
      .catch((err) => {
        setShowLoader(false);
        console.log(err);
      });
  }

  async function handleAddBuilding() {
    if (isBuildingAdd) navigate("/ConfigureBuilding");
    else {
      swal(
        "You have reached maximum capacity to add buildings.",
        "Please update building count and then try again",
        "warning",
        {
          timer: 3000,
          buttons: false,
        }
      );
    }
  }

  async function handleAddWing() {
    if (selectedBuilTotWing > wingList.length) {
      navigate("/EditBuilding/" + selectedBuildingId);
    } else {
      swal(
        "You have reached maximum capacity to add wings.",
        "Please update wing count and then try again",
        "warning",
        {
          timer: 3000,
          buttons: false,
        }
      );
    }
  }

  // End

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        {localStorage.getItem("socityid") ? (
          <Grid container spacing={3} className="mainHeadingLine">
            <Grid item xs={12} md={12} className="oneLineBt">
              <h1 className="panelHeading">
                <EmojiTransportationIcon className="buildingIcoS" />{" "}
                {societyName}
              </h1>
              <Button
                className="primaryBtn"
                onClick={() => navigate("/MasterCalculations")}
              >
                Master Calculations
              </Button>

              {/* <h3 className="societyNameHeading">{societyObj.society_name}</h3> */}
              {/* <Button className="contentTopLefBt">Download</Button> */}

              {/* {localStorage.getItem("buildingCnt") == 0 ? (
                <></>
              ) : (
                <Button
                  className="primaryBtn"
                  onClick={() => handleAddBuilding()}
                >
                  Add building
                </Button>
              )} */}
            </Grid>
            {/* <Grid item xs={12} md={12}>

             
            </Grid> */}
            <Grid item xs={12} md={12}>
              {socimgrrormsg ? (
                <div className="errorField errorFieldFForLogin forInvalidImg topErrorMsg">
                  {socimgrrormsg}
                </div>
              ) : (
                <></>
              )}

              <div className="buildingYesMainNew">
                <div className="buildingYesImgeOut imgSizeDecOut">
                  <div className="imgSizeDec">
                    <span>Note: Minimum image size: 1500x374.</span>
                  </div>
                  <div className="editlayOutPic">
                    <Button className="forUploadOnly">
                      <FileUploadIcon />
                      <input
                        type="file"
                        onChange={(event) =>
                          uploadDocuments(event, "societyImage")
                        }
                        value={ed_societyImage}
                      />
                    </Button>
                  </div>
                  {societyImage ? (
                    <img src={societyImage} />
                  ) : (
                    <img src={defaultBuildImage} />
                  )}
                </div>
                <div className="buldingInnerContent">
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={12}>
                      <h1 className="viewHeading conaInf">Contact Information</h1>
                    </Grid>
                    <Grid item xs={12} md={7}>
                      <div className="tabViewOfProvider">
                        <ul style={{ width: "100%" }}>
                          <li>
                            <span>Name :</span> <b>{societyName}</b>
                          </li>
                          <li>
                            <span>Contact Number :</span> <b>{contact}</b>
                          </li>
                          <li>
                            <span>Email Id :</span> <b>{emailId}</b>
                          </li>
                          <li>
                            <span>Address :</span> <b>{address}</b>
                          </li>
                          {localStorage.getItem("buildingCnt") > 0 ? (
                            <li>
                              <span>Buildings Count :</span>{" "}
                              <b>{buildingCnt}</b>
                            </li>
                          ) : (
                            <></>
                          )}
                          <li>
                            <Button
                              className="editBtn"
                              onClick={handleClickOpen2("body")}
                            >
                              Edit society info
                            </Button>
                          </li>
                        </ul>
                      </div>
                    </Grid>
                    <Grid item xs={12} md={5}>
                      <div className="tabViewOfProviderRight">
                        <h4 className="doquProviderHed">Documents</h4>
                        <div className="societyDoc">
                          <h4 className="documeUpload documeUploadIcon">
                            Upload Documents
                            <Button className="forUploadOnly">
                              <FileUploadIcon />
                              <input
                                type="file"
                                style={{
                                  opacity: 0,
                                  position: "absolute",
                                  left: 0,
                                }}
                                id="documentsList"
                                onChange={(event) => uploadDocuments(event)}
                              />
                            </Button>
                          </h4>
                        </div>
                        {docErrorMsg ? (
                          <div className="errorField errorFieldFForLogin forInvalidFile">
                            {docErrorMsg}
                          </div>
                        ) : (
                          <></>
                        )}
                        {documentsList ? (
                          <>
                            <div className="docScrollBar">
                              {documentsList.map((option, index) => (
                                <div className="doquOut" key={index}>
                                  <div className="doquView1">
                                    <Zoom>
                                      <div className="doquView">
                                        {option.split(".").pop() == "txt" ? (
                                          <img src={txtImage} />
                                        ) : option.split(".").pop() == "pdf" ? (
                                          <img src={pdfImage} />
                                        ) : option.split(".").pop() == "docx" ||
                                          option.split(".").pop() == "doc" ? (
                                          <img src={wordImage} />
                                        ) : option.split(".").pop() == "xls" ||
                                          option.split(".").pop() == "xlsx" ? (
                                          <img src={excelImage} />
                                        ) : (
                                          <img src={option} />
                                        )}
                                      </div>
                                    </Zoom>
                                    <span>
                                      <a href={option}>
                                        {option
                                          .split("/")
                                          .pop()
                                          .replace("%20", " ")}
                                      </a>
                                    </span>

                                    <Button
                                      className="documRemove"
                                      onClick={() => deleteDocument(index)}
                                    >
                                      <DeleteForeverIcon className="deleIco" />
                                    </Button>
                                  </div>
                                  {/* <div className="doquView2">
                          <div className="downLoDoqBt">
                            <UploadIcon />
                            <input type="file" />
                          </div>
                          <span>Document One</span>
                        </div> */}
                                </div>
                              ))}
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                          {gmaperrormsg ? (
                            <div className="errorField errorFieldFForLogin forInvalidImg">
                              {gmaperrormsg}
                            </div>
                          ) : (
                            <></>
                          )}
                        </Grid>
                        <Grid item xs={12} md={6}>
                          {spoterrormsg ? (
                            <div className="errorField errorFieldFForLogin forInvalidImg">
                              {spoterrormsg}
                            </div>
                          ) : (
                            <></>
                          )}
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                          <h4 className="societyImHeading">
                            Society Google map
                          </h4>
                          <div className="blBoxDiv imgSizeDecOut">
                            <div className="imgSizeDec">
                              <span>Note: Minimum image size: 555x374.</span>
                            </div>
                            <img src={googleMapImage} />
                            <div className="editlayOutPic">
                              <Button className="forUploadOnly">
                                <FileUploadIcon />
                                <input
                                  type="file"
                                  onChange={(event) =>
                                    uploadDocuments(event, "googleMap")
                                  }
                                  value={ed_GoogleMap}
                                />
                              </Button>
                            </div>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <h4 className="societyImHeading">Society Layout</h4>
                          <div className="blBoxDiv imgSizeDecOut">
                            <div className="imgSizeDec">
                              <span>Note: Minimum image size: 555x374</span>
                            </div>
                            <img src={spotLayout} />
                            {/* <iframe src={societyObj.google_map_image}></iframe> */}
                            <div className="editlayOutPic">
                              <Button className="forUploadOnly">
                                <FileUploadIcon />
                                <input
                                  type="file"
                                  onChange={(event) =>
                                    uploadDocuments(event, "spotLayout")
                                  }
                                  value={ed_spotLayout}
                                />
                              </Button>
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>

                    {localStorage.getItem("buildingCnt") > 0 ? (
                      <>
                        <Grid item xs={12} md={12}>
                          <div className="allBuildingView">
                            <h1 className="viewHeading">All Buildings</h1>
                            <Grid container spacing={3}>
                              {buildingList.map((option, index) => (
                                <Grid item xs={12} md={3} key={index}>
                                  <div
                                    className="builNoDivOut"
                                    onClick={() =>
                                      handleBuildingSelected(option.building_id)
                                    }
                                  >
                                    {/* <h1>Building {index + 1}</h1> */}
                                    <div
                                      className={
                                        selectedBuildIndex == option.building_id
                                          ? "builNoDivInr activeBuilding"
                                          : "builNoDivInr"
                                      }
                                    >
                                      <h2>{option.building_name}</h2>
                                      <p>Total wings : {option.tot_wing}</p>
                                      <div className="editDeltetIconsDiv">
                                        <CreateIcon
                                          onClick={() =>
                                            navigate(
                                              "/EditBuilding/" +
                                              option.building_id
                                            )
                                          }
                                        />
                                        <DeleteIcon
                                          onClick={() =>
                                            deleteBuilding(option.building_id)
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </Grid>
                              ))}
                              {isBuildingAdd ? (
                                <Grid item xs={12} md={3}>
                                  <Button
                                    className="forAddNewBuilBt"
                                    onClick={() => handleAddBuilding()}
                                  >
                                    <AddIcon /> Add New Building
                                  </Button>
                                </Grid>
                              ) : (
                                <></>
                              )}
                            </Grid>
                          </div>
                        </Grid>
                        {buildingList.length > 0 ? (
                          <Grid item xs={12} md={12}>
                            <div className="buildingDoqumentsDiv">
                              <h1 className="selectedBuildingName">
                                {selectedBuildingName}
                              </h1>
                              <p className="totalWingsHed">
                                {/* Total wings <b>{selectedBuilTotWing}</b> */}
                              </p>
                              {build_DocumentsList.length > 0 ? (
                                <>
                                  <h4 className="doquProviderHed">Documents</h4>
                                  <div className="tabViewOfProviderRight">
                                    {build_DocumentsList.map(
                                      (option1, index) => (
                                        <div className="doquOut" key={index}>
                                          <div className="doquView1">
                                            <Zoom>
                                              <div className="doquView">
                                                {option1.split(".").pop() ==
                                                  "txt" ? (
                                                  <img src={txtImage} />
                                                ) : option1.split(".").pop() ==
                                                  "pdf" ? (
                                                  <img src={pdfImage} />
                                                ) : option1.split(".").pop() ==
                                                  "docx" ||
                                                  option1.split(".").pop() ==
                                                  "doc" ? (
                                                  <img src={wordImage} />
                                                ) : option1.split(".").pop() ==
                                                  "xls" ||
                                                  option1.split(".").pop() ==
                                                  "xlsx" ? (
                                                  <img src={excelImage} />
                                                ) : (
                                                  <img src={option1} />
                                                )}
                                              </div>
                                            </Zoom>
                                            <span>
                                              <a href={option1}>
                                                {option1
                                                  .split("/")
                                                  .pop()
                                                  .replace("%20", " ")}
                                              </a>
                                            </span>
                                          </div>
                                        </div>
                                      )
                                    )}
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                          </Grid>
                        ) : (
                          <></>
                        )}
                        <Grid item xs={12} md={4}>
                          {wingList.length > 0 ? (
                            <>
                              {wingList.map((option2, index) => (
                                <div className="tenentLeftContentMain" key={index}>
                                  <ul>
                                    <li
                                      className={
                                        selectedWingIndex == option2.wing_id
                                          ? "addedApartCont activeTenent"
                                          : "addedApartCont"
                                      }
                                      onClick={() =>
                                        handleWingSelected(option2.wing_id)
                                      }
                                    >
                                      {/* <DeleteIcon className="delIc" /> */}
                                      <h4>
                                        <p>{option2.wing_name}</p>
                                      </h4>
                                      <div className="lineContOuterSt">
                                        <div className="lineContSt">
                                          <span>
                                            Number of floor per wing :
                                          </span>
                                          <h4>{option2.floors_per_wing}</h4>
                                        </div>
                                        <div className="lineContSt">
                                          <span>
                                            Number of apartment per floor :
                                          </span>
                                          <h4>{option2.apartment_per_floor}</h4>
                                        </div>
                                        <div className="lineContSt">
                                          <span>Total apartments :</span>
                                          <h4>
                                            {option2.floors_per_wing *
                                              option2.apartment_per_floor}
                                          </h4>
                                        </div>
                                      </div>
                                      <div className="tailsEditDeleteIcoOut ">
                                        <CreateIcon
                                          className="editIcon"
                                          onClick={handleClickOpen(
                                            "body",
                                            option2
                                          )}
                                        />
                                        <DeleteIcon
                                          className="delIc"
                                          onClick={() =>
                                            deleteWing(option2.wing_id)
                                          }
                                        />
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              ))}
                            </>
                          ) : (
                            <></>
                          )}
                          {isAddWing ? (
                            <Button
                              className="forAddNewBuilBt addNewWingBtn"
                              onClick={() => handleAddWing()}
                            >
                              <AddIcon /> Add New Wing
                            </Button>
                          ) : (
                            <></>
                          )}
                        </Grid>

                        {wingList.length == 0 && isAddWing ? (
                          <Grid item xs={12} md={12}>
                            <div className="errorField errorFieldFForLogin forInvalidImg topErrorMsg">
                              No Wings Found
                            </div>
                          </Grid>
                        ) : (
                          <></>
                        )}

                        {selectedWingIndex ? (
                          <Grid item xs={12} md={8}>
                            <div className="wingsTablsMainDiv priceTbMain wingPriceTbMain">
                              <table width="100%">
                                <thead>
                                  <tr className="thColr">
                                    <th colSpan={5} style={{ fontWeight: 600 }}>
                                      {selectedWingName}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td colSpan={1}>Floors</td>
                                    <td colSpan={4}>Apartments</td>
                                  </tr>

                                  {lstAptHashmap.map((option) => (
                                    <tr key={`option-${option.key}`}>
                                      <td>
                                        <Tooltip title={"Floor " + option.key} arrow>
                                          <span>Floor {option.key}</span>
                                        </Tooltip>
                                      </td>

                                     
                                      {option.apartmentLst.map((option1) => {
                                        const isAllocated = allocatedApartments.includes(option1);
                                        return (
                                          <td
                                            key={`${option.key}-${option1}`}  // Unique key combining floor + apartment
                                            className={isAllocated ? "selectedTd" : ""}
                                          >
                                            <Tooltip title={selectedBuildingName} arrow>
                                              <span>{option1}</span>
                                            </Tooltip>
                                          </td>
                                        );
                                      })}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </Grid>
                        ) : null}
                      </>
                    ) : (
                      <></>
                    )}
                  </Grid>
                </div>
              </div>
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <div className="notConfiguredDiv">
                <h1>Society not Configured yet!</h1>
                <Button
                  className="addBt"
                  onClick={() => navigate("/AddSociety")}
                >
                  Add Society
                </Button>
              </div>
            </Grid>
          </Grid>
        )}
      </div>

      {/* edit wing form */}
      <div className="modalMain">
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Update Wing </span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <div id="successfullAdd">
                <Formik
                  enableReinitialize
                  initialValues={formikInitials}
                  validationSchema={Validation_Schema}
                  onSubmit={updateWing}
                >
                  {({
                    values,
                    handleChange,
                    errors,
                    setFieldTouched,
                    touched,
                    isValid,
                    handleSubmit,
                  }) => (
                    <Form>
                      <Grid container spacing={3} className="addCommitee1">
                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">Wing name</label>
                          {/* <input className="inputSt" placeholder="" value="A" /> */}
                          <input
                            className="inputSt"
                            placeholder="Wing name"
                            value={values.wingname}
                            onChange={handleChange("wingname")}
                            onBlur={() => setFieldTouched("wingname")}
                            onChangeCapture={(e) => setWingname(e.target.value)}
                          />
                          {errors.wingname && touched.wingname ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.wingname}
                            </div>
                          ) : (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {wingNameErrorMsg}
                            </div>
                          )}
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">Number of floors</label>
                          <input
                            className="inputSt"
                            placeholder="Number of floors"
                            value={values.totalfloor}
                            maxLength={3}
                            onChange={handleChange("totalfloor")}
                            onBlur={() => setFieldTouched("totalfloor")}
                            onChangeCapture={(e) =>
                              setTotalfloor(e.target.value)
                            }
                          />
                          {errors.totalfloor && touched.totalfloor ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.totalfloor}
                            </div>
                          ) : (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {floorPerWingErrorMsg}
                            </div>
                          )}
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">
                            Number of apartment floor
                          </label>
                          <input
                            className="inputSt"
                            maxLength={3}
                            placeholder="Number of apartment floor"
                            value={values.aprt}
                            onChange={handleChange("aprt")}
                            onBlur={() => setFieldTouched("aprt")}
                            onChangeCapture={(e) => setAprt(e.target.value)}
                          />
                          {errors.aprt && touched.aprt ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.aprt}
                            </div>
                          ) : (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {aptPerFloorErrorMsg}
                            </div>
                          )}
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">
                            Parking for apartment
                          </label>
                          <input
                            className="inputSt"
                            maxLength={4}
                            placeholder=""
                            value={values.aprtparking}
                            onChange={handleChange("aprtparking")}
                            onBlur={() => setFieldTouched("aprtparking")}
                            onChangeCapture={(e) =>
                              setAprtParking(e.target.value)
                            }
                          />
                          {errors.aprtparking && touched.aprtparking ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.aprtparking}
                            </div>
                          ) : (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {parkingPerAptmtErrorMsg}
                            </div>
                          )}
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <div className="modalMainBtMain">
                            <Button className="modalMainBt" type="submit">
                              Update Wing
                            </Button>
                          </div>
                        </Grid>
                      </Grid>
                    </Form>
                  )}
                </Formik>
                <Grid container spacing={3} className="addCommitee2">
                  <Grid item xs={12} md={12}>
                    <div className="succesMain">
                      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" />
                      <h4>Success !</h4>
                      <p>
                        Updated Wing "A" <br />
                        successfully in database
                      </p>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {/* Edit society Modal ******Start */}
      <div className="modalMain">
        <Dialog
          open={open2}
          // onClose={handleClose2}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Edit Society</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose2} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <Formik
                enableReinitialize
                initialValues={formikInitials_EditSociety}
                validationSchema={Validation_Schema_Editsociety}
                onSubmit={editSociety}
              >
                {({
                  values,
                  handleChange,
                  errors,
                  setFieldTouched,
                  touched,
                  isValid,
                  handleSubmit,
                }) => (
                  <Form>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={12}>
                        <label className="tabsLabel">
                          Society Name <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          className="inputSt"
                          value={values.ed_societyName}
                          onChange={handleChange("ed_societyName")}
                          onBlur={() => setFieldTouched("ed_societyName")}
                          onChangeCapture={(e) =>
                            setEdSocietyName(e.target.value)
                          }
                        />
                        {errors.ed_societyName && touched.ed_societyName ? (
                          <div style={{ color: "red" }} className="errorField">
                            {errors.ed_societyName}
                          </div>
                        ) : null}
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <label className="tabsLabel">
                          Contact number<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          className="inputSt"
                          maxLength={10}
                          value={values.ed_contact}
                          onChange={handleChange("ed_contact")}
                          onBlur={() => setFieldTouched("ed_contact")}
                          onChangeCapture={(e) => setEdContact(e.target.value)}
                        />
                        {errors.ed_contact && touched.ed_contact ? (
                          <div style={{ color: "red" }} className="errorField">
                            {errors.ed_contact}
                          </div>
                        ) : null}
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <label className="tabsLabel">
                          Email Id<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          className="inputSt"
                          placeholder="sampleemail@gmail.com"
                          value={values.ed_emailId}
                          onChange={handleChange("ed_emailId")}
                          onBlur={() => setFieldTouched("ed_emailId")}
                          onChangeCapture={(e) => setEdEmailId(e.target.value)}
                        />
                        {errors.ed_emailId && touched.ed_emailId ? (
                          <div style={{ color: "red" }} className="errorField">
                            {errors.ed_emailId}
                          </div>
                        ) : null}
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <label className="tabsLabel">
                          Address<span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          className="inputSt"
                          placeholder="Address here"
                          value={values.ed_address}
                          onChange={handleChange("ed_address")}
                          onBlur={() => setFieldTouched("ed_address")}
                          onChangeCapture={(e) => setEdAddress(e.target.value)}
                        />
                        {errors.ed_address && touched.ed_address ? (
                          <div style={{ color: "red" }} className="errorField">
                            {errors.ed_address}
                          </div>
                        ) : null}
                      </Grid>
                      {localStorage.getItem("buildingCnt") > 0 ? (
                        <Grid item xs={12} md={12}>
                          <label className="tabsLabel">
                            Buildings Count
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            className="inputSt"
                            placeholder="1"
                            maxLength={2}
                            value={values.ed_buildingCount}
                            onChange={handleChange("ed_buildingCount")}
                            onBlur={() => setFieldTouched("ed_buildingCount")}
                            onChangeCapture={(e) =>
                              setEdBuildingCount(e.target.value)
                            }
                          />
                          {errors.ed_buildingCount &&
                            touched.ed_buildingCount ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.ed_buildingCount}
                            </div>
                          ) : (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {buildingCntErrMsg}
                            </div>
                          )}
                        </Grid>
                      ) : (
                        <></>
                      )}

                      <Grid item xs={12} md={12}>
                        <div className="modalMainBtMain">
                          <Button
                            className="modalMainBt cancelBtForAll"
                            onClick={handleClose2}
                          >
                            Cancel
                          </Button>
                          <Button
                            className="modalMainBt"
                            type="submit"
                          // onClick={() => editSociety()}
                          >
                            Update
                          </Button>
                        </div>
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </div>
          </DialogContent>
        </Dialog>
      </div>
      {/* Edit society Modal ******End */}

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default BuildingYes;
